import React, { useContext, useEffect, useRef, useState } from 'react'
import FinalMolGrid from '../../../components/FinalMolGrid/FinalMolGrid'
import { AdmissionBoardApprovalListConfig } from '../data/AdmissionBoardApprovalListConfig';
import { useLazyGetAllAdmissionBoardApprovalListQuery, useLazyResendSendAdmissionBoardApprovalMailQuery } from '../../../app/services/AdmissionBoardApproval/AdmissionBoardServiceApi';
import { useParams } from 'react-router-dom';
import { decryptAESID } from '../../../utils/Encryption';
import SwalAlert from '../../../services/swalService/SwalService';
import MembershipTaskListContext from '../MembershipTaskListContextProvider';

const AdmissionBoardList = () => {
    const params = useParams();
    const admissionBoardRef = useRef();
    const { success, confirm } = SwalAlert();
    const { taskListDetailsData, admissionBoardCommitteeListData, fetchAdmissionBoardCommitteeList, isAdmissionBoardCommitteeListLoading } = useContext(MembershipTaskListContext);
    const [resendSendAdmissionBoardApprovalMail, {
        isLoading: resendSendAdmissionBoardApprovalMailIsLoading,
        isSuccess: resendSendAdmissionBoardApprovalMailSuccess,
        data: resendSendAdmissionBoardApprovalMailData }] = useLazyResendSendAdmissionBoardApprovalMailQuery();

    useEffect(() => {
        if (!resendSendAdmissionBoardApprovalMailIsLoading && resendSendAdmissionBoardApprovalMailData && resendSendAdmissionBoardApprovalMailSuccess) {
            if (resendSendAdmissionBoardApprovalMailData.admissionBoardApprovalId > 0) {
                success("Email Resend Successfully.");
            }
        }
    }, [resendSendAdmissionBoardApprovalMailIsLoading, resendSendAdmissionBoardApprovalMailData, resendSendAdmissionBoardApprovalMailSuccess]);

    useEffect(() => {
        if (params) {
            let request = {
                ipasMemberId: Number(decryptAESID(params.memberId)),
                taskListId: Number(decryptAESID(params.taskListId)),
            }
            fetchAdmissionBoardCommitteeList(request)
        }
    }, [params]);

    const handleResendClick = (rowData, index) => {
        if (taskListDetailsData?.applicationStatusId === 10) {
            return;
        }
        else if (taskListDetailsData?.isAdmissionBoardSubmittedByAdmin) {
            return; // if alrady submitted then not allow OR Rejected
        }
        else {
            const { admissionBoardApprovalId, name } = rowData;
            confirm('Confirm Resend', `Are you sure you want to resend approval request to: ${name}`, 'Yes', 'NO').then((res) => {
                if (!res)
                    return;
                let request = {
                    admissionBoardApprovalId: admissionBoardApprovalId,
                }
                resendSendAdmissionBoardApprovalMail(request);
            })
        }
    }

    const actionHandler = {
        RESEND: handleResendClick,
    }

    return (
        <div className='table-100'>
            <FinalMolGrid
                ref={admissionBoardRef}
                configuration={AdmissionBoardApprovalListConfig}
                dataSource={admissionBoardCommitteeListData}
                isLoading={isAdmissionBoardCommitteeListLoading}
                allowPagination={false}
                onActionChange={actionHandler}
            />
        </div>
    )
}

export default AdmissionBoardList
